module.exports = __webpack_public_path__ + "img/clientes.a018e051.png";